import React, { useRef, useState } from "react";
import { FaPlay, FaPause } from "react-icons/fa";

const InfluencerSection = () => {
  const videoRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [isPlayingStates, setIsPlayingStates] = useState([false, false, false,false]);

  const handlePlayPause = (e, index) => {
    e.stopPropagation();
    const video = videoRefs[index].current;
    if (!video) return;

    const updatedStates = [...isPlayingStates];
    if (isPlayingStates[index]) {
      video.pause();
      updatedStates[index] = false;
    } else {
      video.play();
      updatedStates[index] = true;
    }

    setIsPlayingStates(updatedStates);
  };

  const handleDivClick = (url) => {
    window.open(url, "_blank");
  };

  const influList = [
    {
      videoName: "video3",
      videolink: "/video3.mp4",
      videoPath: "https://www.instagram.com/reel/DJ0v59XzGSZ/?igsh=MWlnMDNiano5NHh6eg==",
      videoThumbnail: "video3.jpeg",
      banner: "JERRY200",
    },
    {
      videoName: "video4",
      videolink: "/video4.mp4",
      videoPath: "https://www.instagram.com/reel/DHn1RxLi6I-/?igsh=MWhnaWJ2ZW11eDltZw==",
      videoThumbnail: "video4.jpg",
      banner: "25% OFF ON SETS",
    },
    {
      videoName: "video1",
      videolink: "/video1.mp4",
      videoPath: "https://www.instagram.com/reel/DFUvBQ8o0je/?igsh=dDB4ZXZsdzBybXBq",
      videoThumbnail: "video1.jpg",
      banner: "25% OFF ON RINGS",
    },
    {
      videoName: "video2",
      videolink: "/video2.mp4",
      videoPath: "https://www.instagram.com/reel/DEfGLySJa9n/?igsh=MTl5empmNWtzd253cQ==",
      videoThumbnail: "video2.jpg",
      banner: "25% OFF ON RINGS",
    },
  ];

  return (
    // <div
    // className="mx-auto w-full bg-conver bg-no-repeat"
    // style={{ backgroundImage: "url('/influBg.png')"}}
    // >

    <div className="mx-auto relative bg-cover bg-no-repeat bg-gradient-to-r from-[#F3F3FD] to-white"
    // style={{
    //   backgroundImage: "linear-gradient(to right, #F3F3FD, white), url('/in_bg.png')",
    //   backgroundBlendMode: "overlay",
    //   zIndex: 2,
    // }}
    >

      {/* Top-right decorative image */}
      <img
        src="/top-right.png"
        alt="Top Right Decoration"
        className="absolute top-0 right-0 w-[80px] md:w-[160px] h-auto"
      />

      {/* Bottom-left decorative image */}
      <img
        src="/bottom-left.png"
        alt="Bottom Left Decoration"
        className="absolute bottom-0 left-0 w-[100px] h-auto"
      />

      <div className="flex flex-col items-center gap-1 py-8 px-4">
        <p className="text-center text-base font-semibold uppercase z-10">INFLUENCER CORNER</p>
        <p className="text-center text-2xl md:text-3xl font-semibold text-[#C71C8E] z-10">
          Discover their Story
        </p>
        <p className="text-center text-sm font-semibold z-10">
          with <span className="text-[18px] text-[#000080] z-10">SAIRAH</span>
        </p>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-8 md:px-12 lg:px-20 pb-10">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {influList.map((item, index) => (
            <div key={item.videoName} className="w-full">
              <div
                className="h-[260px] md:h-[460px] bg-white rounded-lg overflow-hidden relative cursor-pointer border-4 border-[#9797E9] shadow-md"
                onClick={() => handleDivClick(item.videoPath)}
              >
                <video
                  ref={videoRefs[index]}
                  src={item.videolink}
                  className="w-full h-full object-cover"
                  preload="metadata"
                  poster={item.videoThumbnail}
                  onEnded={() => {
                    const video = videoRefs[index].current;
                    if (video) {
                      video.load();
                      const updatedStates = [...isPlayingStates];
                      updatedStates[index] = false;
                      setIsPlayingStates(updatedStates);
                    }
                  }}
                />
                <div className="absolute bottom-3 right-1 md:right-2 z-10">
                  <button
                    className="bg-[#22229399] text-white p-3 rounded-full"
                    onClick={(e) => handlePlayPause(e, index)}
                  >
                    {isPlayingStates[index] ? (
                      <FaPause className="text-[10px] md:text-[18px]" />
                    ) : (
                      <FaPlay className="text-[10px] md:text-[18px]" />
                    )}
                  </button>
                </div>

                <div className="absolute bottom-3 left-2 z-10">
                  {index === 0 ? (
                    <div className="flex items-center px-4 py-2 rounded-md bg-[#22229399] text-white">
                      <p className="text-[8px] md:text-sm md:text-base font-[860]">Code</p>
                      <div className="ml-2 bg-white rounded-md">
                        <p className="px-2 py-1 text-[8px] md:text-sm font-[600] text-[#C71C8E]">
                          {item.banner}
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center px-4 py-2 rounded-md bg-[#22229399] text-white">
                      <p className="text-[8px] md:text-sm md:text-base font-[600]">{item.banner}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InfluencerSection;
